export const withShortFormat = (value: number) => {
  if (value >= 1000000) return `${(value / 1000000).toFixed(1)}M`;
  else if (value >= 1000) return `${(value / 1000).toFixed(1)}K`;
  return value;
};
